<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Administration</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Custom Tags
                </li>
              </ol>
            </nav>

            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                  v-if="isAllowToCreate"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Custom Tags<span><i class="ic-time"></i></span>
                  </h2>
                  <p>
                    Manage custom tags data as part of your business offering.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>No</th>
                  <!-- <th>Type</th> -->
                  <th>Name</th>
                  <th>Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="detail-row"
                  v-for="(item, index) in items"
                  :key="item.id"
                >
                  <td>{{ index + 1 }}</td>
                  <!-- <td>{{ item.typeDescription }}</td> -->
                  <td>{{ item.name }}</td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                        v-if="isAllowToUpdate"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                        v-if="isAllowToDelete"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="regionmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Tag</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <!-- <div class="form-group" v-if="!isUpdate">
                      <label class="required">Type</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error': isSubmitted && $v.model.type.$error,
                        }"
                        placeholder="Select type"
                        label="text"
                        v-model="model.type"
                        :options="taggingTypes"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      />
                      <div v-if="isSubmitted && $v.model.type.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.type.required"
                          >Type is required</small
                        >
                      </div>
                    </div> -->
                    <div class="form-group">
                      <label class="required">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.name.$error,
                        }"
                        autocomplete="off"
                        v-model="model.name"
                        placeholder="Enter a Name"
                      />
                      <div v-if="isSubmitted && $v.model.name.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.name.required"
                          >Name is required</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Background Color</label>
                      <div class="form-color">
                        <input
                          type="text"
                          class="form-control color-field"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.backgroundColor.$error,
                          }"
                          v-model="model.backgroundColor"
                          placeholder="Enter a Background Color"
                          data-coloris
                        />
                        <span
                          class="color"
                          :style="`background: ${model.backgroundColor}`"
                        ></span>
                      </div>
                      <div
                        v-if="isSubmitted && $v.model.backgroundColor.$error"
                      >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.backgroundColor.required"
                          >Background Color is required</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Text Color</label>
                      <div class="form-color">
                        <input
                          type="text"
                          class="form-control color-field"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.textColor.$error,
                          }"
                          v-model="model.textColor"
                          placeholder="Enter a Text Color"
                          data-coloris
                        />
                        <span
                          class="color"
                          :style="`background: ${model.textColor}`"
                        ></span>
                      </div>
                      <div v-if="isSubmitted && $v.model.textColor.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.textColor.required"
                          >Text Color is required</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import rateTagService from "@/services/master/rateTag/rateTagService.js";
import { TaggingTypes } from "@/models/constants";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      allPermissions: [],
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
      taggingTypes: TaggingTypes,
    };
  },
  validations() {
    return {
      model: {
        name: { required },
        textColor: { required },
        backgroundColor: { required },
        name: { required },
        type: {},
        // type: this.isUpdate ? {} : { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
    }
  },
  mounted() {
    $(this.$refs.regionmodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("rate-tagging-link");
    this.$helper.alphabetsOnly();
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.regionmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.isUpdate = false;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.regionmodal).modal("hide");
    },
    createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.openModal({
        name: null,
        type: null,
        textColor: "#fff",
        backgroundColor: "#4fb848",
      });
    },
    updateItem(item) {
      const objectData = {
        id: item.id,
        type: item.typeDescription,
        name: item.name,
        backgroundColor: item.backgroundColor,
        textColor: item.textColor,
        isActive: item.isActive,
      };
      this.isUpdate = true;
      this.openModal(objectData);
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      this.isLoading = true;
      try {
        let filter = `?keyword=${this.table.keyword}&page=${this.table.pageNumber}&pageSize=${this.table.pageSize}`;
        const response = await rateTagService.getAllWithSearch(filter);
        this.items = response.data.items;
        this.table.totalPages = response.data.totalPages;
        this.table.totalRecords = response.data.totalItems;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    changeStatus(item) {
      this.model = {
        id: item.id,
        name: item.name,
        isActive: item.isActive,
      };
      this.isUpdate = true;

      this.submit();
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        const payload = {
          ...this.model,
          type: "Tariff",
        };
        if (this.isUpdate) {
          await rateTagService.update(payload);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await rateTagService.create(payload);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await rateTagService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.btn-view {
  padding: 3px 7px;
  border: none;
  border-radius: 3px;
  margin-left: 3px;
}

.btn-view svg {
  width: 13px;
  height: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/tag/Tag.vue